import { isBrandRefreshEnabled } from '../../../../shared/utilities/brandRefresh';

/** Brand-refresh hamburger menu UI only when REACT_APP_BRAND_REFRESH_ENABLED === 'true'. */
export const isHamburgerMenuBrandRefresh = () => isBrandRefreshEnabled();

/** data-region value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getHamburgerRegionProps = () =>
  isBrandRefreshEnabled() ? 'fullscreen-homepage-hamburger-menu' : undefined;

/** data-part value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getHamburgerPartProps = (part) =>
  isBrandRefreshEnabled() ? part : undefined;

/** Pick brand asset when flag is on; otherwise legacy. */
export const getHamburgerIcon = (legacyIcon, brandRefreshIcon) =>
  isBrandRefreshEnabled() ? brandRefreshIcon : legacyIcon;
